import { isQubictronLocHostname } from "@qubictron/url";
import { Assets } from "@qubictron/url/client";

export { createScacIconUrl } from "@qubictron/url/client";

export const isAppComDomain = /qubictron\.com$/gi.test(window.location.hostname);

export const assets = new Assets({
  appFolder: __APP_FOLDER__,
  hash: __DEV__ ? new Date().getTime().toString() : __APP_VERSION__,
  originResolverCallbackMap: {
    localhost: () => ({ url: __APP_ORIGIN__ }),
    loc: () => ({ url: window.location.origin }),
  },
});

export const STATIC_IMAGES = ((): string => {
  const location = window.location.href;

  if (location.includes("local.qubictron.com")) {
    return "https://local.qubictron.com:3000/apps/contact-us/static/images";
  }
  if (isQubictronLocHostname(window.location.hostname)) {
    return `${window.location.origin}/apps/contact-us/static/images`;
  }

  return "https://apps.qubictron.com/apps/contact-us/static/images";
})();

export const APP_STYLESHEET_HREF = assets.css.appBundleBuilder().build();

export const APP_FONTS_STYLESHEET_HREF = assets.css.fonts.bundleBuilder().build();

export const APP_FONTS_REGISTER_STYLESHEET_HREF = assets.css.fonts.bundleRegisterBuilder().build();

export const getCountryFlagUrl = (countryCode: string): string => {
  const code = countryCode.trim().toLowerCase();
  if (!code) {
    return "";
  }
  return `${STATIC_IMAGES}/Icons/flags/${code}.svg`;
};
